import { Box, CircularProgress } from "@mui/material";

const Loader = ({sx}) => {
  return (
    <Box
      sx={{
        width: 1,
        height: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        alignContent: "center",
        ...sx,
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Loader;
